import React, { useEffect } from "react";

// How-to video for logging km by hand (Vimeo embed link).
const MANUAL_TRACKING_VIDEO_URL = "https://player.vimeo.com/video/1241289688";

export default function ManualTrackingOverlay({ onClose }) {
  useEffect(() => {
    const onKey = (event) => event.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="rr-modal-backdrop" onClick={(event) => event.target === event.currentTarget && onClose()}>
      <div className="rr-modal" role="dialog" aria-modal="true" aria-labelledby="rr-manual-title">
        <button type="button" className="rr-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="rr-manual-title" className="rr-modal-title">
          How to log your km
        </h2>
        <div className="rr-video">
          {MANUAL_TRACKING_VIDEO_URL ? (
            <iframe src={MANUAL_TRACKING_VIDEO_URL} title="How to log your km" allow="fullscreen; picture-in-picture" allowFullScreen />
          ) : (
            <span>Video coming soon</span>
          )}
        </div>
        <ol className="rr-modal-steps">
          <li>Open your dashboard.</li>
          <li>Tap Add Activity Manually.</li>
          <li>Enter your km and the date. Done!</li>
        </ol>
        <button type="button" className="rr-btn rr-btn-primary rr-modal-done" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}
